import { enqueueSnackbar } from 'notistack';
import { io } from 'socket.io-client';

let socket = null;
const SOCKET_HOST_URL = process.env.REACT_APP_SOCKET_HOST_URL;

export const connectSocket = async (user) => {
    try {

        if (!user?._id) return;

        // Disconnect any prior socket synchronously before creating a new one.
        // Previously this only happened inside the async 'connect' callback, so
        // an unmount that raced ahead of that event left the old socket assigned
        // to nothing and never disconnected — a leaked, still-listening socket.
        if (socket) {
            socket.disconnect();
        }

        const newSocket = io(`${SOCKET_HOST_URL}?user_id=${user?._id}`);
        socket = newSocket;

        newSocket.on('connect', () => {
            console.log('Socket connected');
        });

        newSocket.on('error', (error) => {
            console.log('Socket error:', error);
            enqueueSnackbar(error, { variant: 'error' });
        });

        newSocket.on('disconnect', () => {
            console.log('Socket disconnected');
        });
    } catch (error) {
        console.error('Error retrieving token from user:', error);
    }
};

export const getSocket = () => socket;
export const joinConversation = (conversationId, setSocket) => {

    if (!socket || !conversationId) return;


    socket.emit("joinConversation", {
        conversationId: conversationId
    })
    setSocket(socket);
}

export const subscribeUnreadCount = (callback) => {
    if (!socket) return () => {};

    const handler = (data) => {
        callback(data.chatUnreadCount);
    };

    socket.on("unreadCountMessages", handler);

    // Request initial count
    socket.emit("getUnreadCountMessages");

    return () => {
        socket.off("unreadCountMessages", handler);
    };
};

export const subscribePlatformAccess = (callback) => {
    if (!socket) return () => {};

    const handler = (data) => {
        console.log('Received platform access update:', data);
        callback(data);
    };
    socket.on("updatePlatformAccess", handler);
    return () => {
        socket.off("updatePlatformAccess", handler);
    };
};
export const isSocketConnected = () => {
    return socket?.connected;
};
export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        console.log('Socket disconnected manually');
    }
};
